import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import numeral from "numeral";
import React from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";
import "./style.scss";

const VatLineRow = ({ line, currentSettlement, journalType, monthNumber }) => {
  const navigate = useNavigate();
  const total = line?.taxable + line?.tax;

  return (
    <div className="vatLine">
      <div style={{width: "28%"}}>
        &nbsp;
      </div>
      <div style={{width: "16%"}}>
        <FormattedMessage id={`reports.vatEntries.table.taxEnums.${line?.type}`} />        
      </div>
      <div style={{width: "16%", whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis", paddingRight: "4px"}}>
        <Tooltip title={line?.description} placement="topLeft" color="#005075">
          {line?.description}
        </Tooltip>        
      </div>
      <div style={{width: "10%"}}>
        {`${numeral(Math.abs(line.taxable)).format("0,0.00")} €`}
      </div>
      <div style={{width: "10%"}}>
        {`${numeral(Math.abs(line.tax)).format("0,0.00")} €`}
      </div>
      <div style={{width: "10%"}}>
        {`${numeral(Math.abs(line?.nonDeductibleAmount)).format("0,0.00")} €`}
      </div>
      <div style={{width: "10%"}}>
        {`${numeral(Math.abs(total)).format("0,0.00")} €`}
      </div>
      <div
        style={{ width: "3%", textAlign: "center", color: "#0090d1", cursor: "pointer" }}
        onClick={() => navigate(`/reports/aliquote-detail/${line.type}`, { state: { year: currentSettlement.year, month: monthNumber, businessId: currentSettlement.businessId, type: line.type, journalType:journalType } })}
      >
        <FontAwesomeIcon icon={["far", "angle-right"]}/>
      </div>
    </div>
  );
};
export default VatLineRow;
